import { DESKTOP_MIN_WIDTH, type PlatformInfo, TABLET_MIN_WIDTH } from './types';

/**
 * Web detectPlatform — reads from window viewport + pointer media query.
 *
 * SSR-safe: returns a desktop-ish default when `window` is undefined.
 * Not reactive — call again on resize, or use usePlatformValue / useBreakpoint
 * for components that need to update on viewport changes.
 */
export function detectPlatform(): PlatformInfo {
  if (typeof window === 'undefined') {
    return {
      os: 'web',
      isPad: false,
      isAndroidTablet: false,
      isAndroidPhone: false,
      isTablet: false,
      isPhone: false,
      isDesktop: true,
      isTouch: false,
      isNative: false,
    };
  }

  const width = window.innerWidth;
  const isCoarsePointer =
    typeof window.matchMedia === 'function'
      ? window.matchMedia('(pointer: coarse)').matches
      : false;

  const isTablet = width >= TABLET_MIN_WIDTH && width < DESKTOP_MIN_WIDTH;
  const isPhone = width < TABLET_MIN_WIDTH;
  const isDesktop = width >= DESKTOP_MIN_WIDTH;

  return {
    os: 'web',
    isPad: false,
    isAndroidTablet: false,
    isAndroidPhone: false,
    isTablet,
    isPhone,
    isDesktop,
    isTouch: isCoarsePointer,
    isNative: false,
  };
}
